import { trackEvent } from '@patrianna/analytics'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import content from 'prismic-translates/loginpage.json'

import classes from '../styles.module.scss'

import LoginForm from './LoginForm'

const t = getTranslationFromJson([content])

type LoginProps = {
  onForgotPassword: () => void
}

export default function ManualLogin(props: LoginProps) {
  return (
    <>
      <LoginForm />

      <span
        className={cx('mt-typography-caption', classes.forgotPass)}
        onClick={() => {
          props.onForgotPassword()
          trackEvent('login_page_forgot_password_link')
        }}
        data-test='forgot-pass-link'
      >
        {t('forgotPassword')}
      </span>
    </>
  )
}
